import { gql } from '@apollo/client';

export const TEST_SESSION = gql`
  query TestSession($id: ID!) {
    testSession(id: $id) {
      id
      isPreview
      expiresAt
      tester {
        id
        project {
          id
          name
          description
          testType
          status
          sessionDuration
          audienceParticipants
          ndaRequired
          studyContext
          otherTesterRequirements
          participantsSource
          lockVersion
          sortType
          randomCategory
          sortRandom
          tooltipDescription
          uploadImage
          hideName
          instructionsContent
          welcomeContent
          thankYouContent
          instructionsTitle
          welcomeTitle
          thankYouTitle
          segments{
            audienceTemplate {
              id
              name
            }
          }
          cardSortItems {
            id
            name
            description
            itemOrder
            imageKey
            imageUrl
          }
          cardSortCategories {
            id
            name
            isDefault
            categoryOrder
          }
          questionTemplate {
            id
            name
          }
          audienceAttributes {
            id
            audienceAttributeType
            audienceAttributeOptions {
              id
              value
            }
          }
          company {
            id
          }
          surveys {
            id
            surveyType
            questions {
              id
              label
              questionType
              groupId
              questionOrder
              leftLabel
              rightLabel
              imageUrl
              imageKey
              blurVideo
              treeTestNodes {
                id
              }
              followUpQuestions{
                id
                label
                questionType
                leftLabel
                rightLabel
                questionOrder
                questionOptions {
                  id
                  label
                  disqualify
                  qualify
                }
              }
              questionOptions {
                id
                label
                disqualify
                qualify
                optionType
                order
              }
            }
            surveysPages {
              id
              pageName
              order
              questions {
                id
                label
                questionType
                groupId
                questionOrder
                leftLabel
                rightLabel
                blurVideo
                questionOptions {
                  id
                  label
                  disqualify
                  qualify
                  optionType
                  order
                }
              }
            }
          }
          treeTestNodes {
            id
            label
            parentId
            order
            projectId
          }
        }
      }
    }
  }
`;
